/** Grymwyrd — conteúdo em português brasileiro para o herói da página inicial. */
export const homePtBR = {
  'home.heroEyebrow': 'Um mundo de horror-fantasia vivido',
  'home.heroTitle': 'Entre no Crepúsculo',
  'home.heroBody':
    'Grymwyrd é um mundo obcecado de horror gótico vitoriano, onde a cidade de Greywick, afogada em névoa, esconde torres arruinadas, subsolos de mansões e rituais que é melhor deixar sem ser ditos. Forje um herói, levante os véus do Cataclismo e grave seu nome em um mundo que se lembra.',
  'home.heroPlayCta': 'Jogar Agora',
  'home.heroBrowseCta': 'Explorar Enciclopédia',
  'home.heroQuickstartPrompt': 'Não está pronto para jogar? Pegue o Quickstart gratuito',
}
